/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.1.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2023 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import App from "./App.vue";
// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";

// router setup
import routes from "./routes/routes";

import "./registerServiceWorker";

// Attach auth token to every API request for role enforcement
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("userToken");
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});

// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: "nav-item active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

function isTokenValid(token) {
  if (!token) return false;
  try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = JSON.parse(atob(base64));
      const now = Date.now() / 1000;
      return jsonPayload.exp > now;
  } catch (e) {
      console.error('Invalid token:', e);
      return false;
  }
}

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('userToken');
  if (to.matched.some(record => record.meta.requiresAuth)) {
      if (isTokenValid(token)) {
          next();
      } else {
          localStorage.removeItem('userToken')
          localStorage.removeItem('username')
          next('/login');
      }
  } else {
      next();
  }
});

// router.beforeEach((to, from, next) => {
//   const isLoggedIn = !!localStorage.getItem('userToken'); // Replace with your actual login check logic

//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (!isLoggedIn) {
//       next({ path: '/login' });
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
});
